import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function ApiKeysLoader() {
  return (
    <div className="space-y-6">
      {/* JWT Token Card skeleton */}
      <Card className="p-6">
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-2">
              <Skeleton className="h-5 w-48" />
              <Skeleton className="h-4 w-80" />
            </div>
            <Skeleton className="h-9 w-24" />
          </div>
          <div className="grid grid-cols-2 gap-4 pt-4 border-t">
            {["a", "b", "c", "d"].map((k) => (
              <div key={k} className="space-y-1">
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-4 w-40" />
              </div>
            ))}
          </div>
        </div>
      </Card>

      {/* API Keys Table skeleton */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <Skeleton className="h-5 w-24" />
            <Skeleton className="h-4 w-64" />
          </div>
          <Skeleton className="h-9 w-32" />
        </div>
        <Card className="p-4 space-y-3">
          {["a", "b", "c"].map((k) => (
            <Skeleton key={k} className="h-12 w-full" />
          ))}
        </Card>
      </div>
    </div>
  );
}
